import 'react-phone-input-2/lib/style.css'
import { memo, useEffect, useState } from 'react'
import PhoneInput from 'react-phone-input-2'
import { Button } from 'react-bootstrap';
import ApiService from '../../../../Services/ApiService';
import AlertService from '../../../../Services/AlertService';
import OtpInput from 'react-otp-input'
import CountdownTimer from '../CountdownTimer/CountdownTimer';

const KycVerification = memo(({
  isLoading,
  setIsLoading,
  countries,
  isTransactionValidated,
  getFail,
  kyc_numbers,
  set_kyc_numbers,
  showOTPloader,
  setActiveTab,
  smsDeadline,
  clearOTPInputs
}) => {

  const [isShowLoader, setIsShowLoader] = useState(false);
  const [isKycSent, setIsKycSent] = useState(false);
  const [otpTimer, setOtpTimer] = useState(null);
  const [values, setValues] = useState({
    phoneNumber: "",
  })

  useEffect(() => {
    if (smsDeadline) {
      setOtpTimer(smsDeadline > 0 ? smsDeadline : 0);
      setIsKycSent(true);
    }
  }, [smsDeadline])

  const onPhoneNumberChange = (event, fieldName) => {
    setValues(values => ({ ...values, [fieldName]: event }))
  };

  const getSecondsDifference = (isoTime) => {
    if (!isoTime) { return }
    const givenTime = new Date(isoTime);
    const currentTime = new Date();
    const diffInMs = givenTime.getTime() - currentTime.getTime();
    const diffInSeconds = diffInMs / 1000;
    return Math.round(diffInSeconds) || 0;
  }

  const sendKycData = () => {
    setIsLoading(true);
    setIsShowLoader(true);
    const data = {
      phone: values.phoneNumber,
    }
    ApiService.sendKycData(data).then((response) => {
      if (response && response.data && response.data.smsTokenDeadline) {
        const secondsDiff = getSecondsDifference(response.data.smsTokenDeadline);
        setOtpTimer(secondsDiff);
        setIsKycSent(true);
        AlertService.alert("success", "The verification code has been sent.");
      }
    }).catch(error => getFail(error)).finally(() => {
      setIsShowLoader(false);
      setIsLoading(false);
    });
  }

  return (

    <div>
      <div className="mb-3 title-block"><strong>OTP</strong></div>
      <div className="mt-3 p-3">
        {
          isTransactionValidated ? null :
            <>
              <div>
                <p className='fw-500'>
                  {
                    isTransactionValidated ? "OTP (One Time Password) verified" : "OTP (One Time Password) verification"
                  }
                </p>
                <div className={`${isTransactionValidated ? "disabled" : ""}`}>
                  <small>Please enter your phone number to continue.</small>
                  <div className="cx-phone-number-block mb-1">
                    {
                      countries && countries.length ?
                        <PhoneInput
                          country={values.selectedCountryId ? countries.find(item => item.id === values.selectedCountryId)?.isoCode2.toLowerCase() : "hk"}
                          value={values.phoneNumber}
                          className={`custom-phone-number-input-block ${isLoading || typeof otpTimer === "number" ? " disabled" : ""}`}
                          onChange={(event) => onPhoneNumberChange(event, "phoneNumber")}
                          disabled={isTransactionValidated}
                          onKeyDown={(event) => {
                            if (event.key === "Enter") {
                              event.preventDefault();
                              if (isKycSent) { return false; }
                              sendKycData();
                            }
                          }}
                        />
                        : null
                    }
                  </div>
                  <div className="d-flex form-group justify-content-end">
                    <Button
                      id="send_kyc"
                      variant='primary'
                      className={`
                mt-2 mx-0 px-4
                ${!values.phoneNumber ||
                          isLoading ||
                          isShowLoader ||
                          isTransactionValidated || isKycSent ?
                          "disabled" :
                          ""}`
                      }
                      onClick={sendKycData}
                    >
                      {
                        isShowLoader ? "Loading..." : "Send"
                      }
                    </Button>
                  </div>
                </div>
              </div>
              <hr />
              <div className={`${!isKycSent && !isTransactionValidated ? "disabled" : ""}`}>
                <div>
                  <div className='fw-500 mb-3'>
                    {
                      isTransactionValidated ?
                        "SMS verified." :
                        <span className='d-flex gap-2'>
                          Please, type OTP Code
                          {
                            typeof otpTimer === "number" && otpTimer !== 0 ?
                              <CountdownTimer
                                initialSeconds={otpTimer}
                                cb={setOtpTimer}
                              />
                              : null
                          }

                        </span>
                    }
                  </div>
                </div>

                <div className={`${isTransactionValidated ? "disabled" : ""}`}>
                  <small>Enter the code sent to your phone to proceed.</small>
                  {
                    otpTimer === 0 ?
                      <div className='mb-2'>
                        <small>Didn’t receive it?{" "}
                          <span
                            className='text-center'
                            style={{ textDecoration: "underline", cursor: "pointer" }}
                            to="#"
                            onClick={() => {
                              setValues((values) => ({
                                ...values,
                                phoneNumber: ""
                              }));
                              setIsKycSent(false);
                              setOtpTimer(null);
                              clearOTPInputs();
                              const phoneInput = document.querySelector('.react-tel-input.custom-phone-number-input-block input');
                              if (phoneInput) {
                                phoneInput.focus();
                              }
                            }}>
                            <small>Try Again</small>
                          </span>
                        </small>
                      </div>
                      : null
                  }
                  <div className="cx-accordion-body-list cx-overflow-inherit position-relative bg-white">
                    <div
                      className={`cx-accordion-body-number-item  ${showOTPloader || isTransactionValidated ? "disabled" : ""}`}
                    >
                      <OtpInput
                        value={kyc_numbers}
                        onChange={set_kyc_numbers}
                        inputType="number"
                        numInputs={8}
                        shouldAutoFocus={isKycSent && !isTransactionValidated ? true : false}
                        renderSeparator={<span>&nbsp;</span>}
                        renderInput={(props, index) => <input {...props} id={`kyc_${index}`} className="kyc-number" disabled={(showOTPloader || !otpTimer) ? true : false} />}
                      />
                    </div>
                  </div>
                </div>

              </div>
            </>
        }
        <div>
          {
            isTransactionValidated ? null : <hr />
          }
          <p className='fw-500'>
            To make a payment, please:
          </p>
          <div>
            <ul className='mb-1'>
              <li style={{ listStyleType: "none" }}><small>1: Complete the <b>OTP verification</b></small></li>
              <li style={{ listStyleType: "none" }}><small>2: Select the <b
                style={{ cursor: `${isTransactionValidated ? "pointer" : "default"}`, textDecoration: `${isTransactionValidated ? "underline" : "none"}` }}
                onClick={() => {
                  if (isTransactionValidated) {
                    setActiveTab(2);
                  }
                }}
              >
                network & token
              </b></small></li>
              <li style={{ listStyleType: "none" }}><small>3: Connect your <b
                style={{ cursor: `${isTransactionValidated ? "pointer" : "default"}`, textDecoration: `${isTransactionValidated ? "underline" : "none"}` }}
                onClick={() => {
                  if (isTransactionValidated) {
                    setActiveTab(3);
                  }
                }}
              >
                wallet
              </b></small></li>
            </ul>
            <small>Once connected, you can proceed with the payment.</small>
          </div>

        </div>
      </div>
    </div>
  )
})

export default KycVerification;